import { render, staticRenderFns } from "./DataProcessing.vue?vue&type=template&id=0d35ad1c"
import script from "./DataProcessing.vue?vue&type=script&lang=js"
export * from "./DataProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports